import React from 'react'
import { authHeader, userDetails } from '../../utils'
import DropdownMenu from '../elements/DropdownMenu'
import ChevronIcon from '../elements/icons/ChevronIcon'
import { useDispatch } from 'react-redux'
import { ERROR } from '../../store/types'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import LogoutIcon from '../elements/icons/LogoutIcon'
// import BellIcon from '../elements/icons/BellIcon'

const UserHeader = () => {
    const user = userDetails()
    const dispatch = useDispatch()
    let navigate = useNavigate()

    const menuOptions = [
        {
            label: 'Profile',
            action: ()=>{navigate('/user/profile')}
        },
        {
            icon: <LogoutIcon className={`w-5 h-5 text-gray-300 mr-2`} />,
            label: 'Logout',
            action: ()=>{logout()}
        },
    ]

    const logout = async () => {
        try {
            const headers = authHeader()
            await axios.delete(`${process.env.REACT_APP_BASE_URL}/auth/sessions`, { headers })            

            localStorage.removeItem("userDetails");
            localStorage.removeItem("authToken");

            navigate("/")
            
        } catch (error) {
            dispatch({
                type: ERROR,
                error
            })
        }
    }
    const MenuButton = () => (
        <div className='flex items-center gap-x-2'>
            <div className='w-[50px] h-[50px] flex items-center justify-center'>
                <div className='flex items-center justify-center bg-vcm-light-purple w-[45px] h-[45px] rounded-full border border-vcm-purple uppercase'>
                    <p className='text-xl uppercase text-vcm-purple'>
                        {user?.parentProfile?.firstName?.charAt(0)}{user?.parentProfile?.lastName?.charAt(0)}
                    </p>
                </div>
            </div>
            <div className='w-full hidden lg:block'>
                <p>{user?.name}</p>
            </div>
            <div className='flex items-center justify-center w-[20px]'>
                <ChevronIcon className={`w-4 h-4 text-gray-400 -rotate-90`} />
            </div>
        </div>
    )

    return (
        <div className='w-full px-5 xl:px-32 2xl:px-44 flex items-center justify-between h-[75px] border-b'>
            <h1 className="font-thin text-primary text-opacity-80 tracking-[0.2em] uppercase">
                vaatia college <span className='hidden lg:inline-block'>makurdi</span><span className='lg:hidden'>mkd</span>
            </h1>

            <div className='flex flex-row-reverse gap-x-4'>
                <DropdownMenu userName={user?.name} button={MenuButton} menuItems={menuOptions} />
                {/* <Link to={`/user/notifications`}>
                    <button className='w-[50px] h-[50px] rounded-full flex items-center justify-center bg-gray-100 relative text-vcm-purple'>
                        <div className='w-[7px] h-[7px] rounded-full bg-red-500 absolute top-[0px] right-[0px]'></div>
                        <BellIcon className="w-4 h-4" />
                    </button>
                </Link> */}
            </div>
        </div>
    )
}

export default UserHeader